module.exports = __webpack_public_path__ + "img/refund_success.1f897789.png";